// Widget Scripts
import splashPageFeature from './js/widgets/splashPageFeature.js';
import buyTicketButton from './js/widgets/buyTicketButton.js';
import mainSlideshow from './js/widgets/mainSlideshow.js';
import mainCards from './js/widgets/mainCards.js';
import mainSeoBlock from './js/widgets/mainSeoBlock.js';
import * as socialVideo from './js/widgets/social-video/index.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  globalThis.splashPage && splashPageFeature(splashPage);
  buyTicketButton();

  if (globalThis.location.pathname === '/') {
    mainSlideshow();
    mainCards();
    mainSeoBlock();

    $(globalThis).load(function () {
      socialVideo.videoWidget();
      socialVideo.facebookfeed();
    });

    scrollerSponsors();
  }
});
